exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".operation-wrapper[data-v-5735480b]{display:flex;flex-wrap:wrap;width:472px;margin:150px auto 0;background-color:hsla(0,0%,100%,.91);margin-bottom:32px}.operation-item[data-v-5735480b]{width:228px;height:162px;border-radius:4px;cursor:pointer;box-shadow:0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04)}.operation-text[data-v-5735480b]{display:flex;align-items:center;justify-content:center;width:100%;height:100%;font-size:20px;font-weight:700;color:#fff}.operation-item[data-v-5735480b]:first-child{background-color:#5d77ad;margin-right:16px;margin-bottom:16px}.operation-item[data-v-5735480b]:nth-child(2){background:linear-gradient(60deg,#336fb7,#3b5aa7,#4350a0,#434fa0);margin-bottom:16px}.operation-item[data-v-5735480b]:nth-child(3){margin-right:16px;background-color:#f5be6b}.operation-item[data-v-5735480b]:last-child{background-color:#3fd4b6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5735480b&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/index.vue
// module id = 537
// module chunks = 0